/* CustomerPrivacyAndSecurityTab.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import SectionMessage from '@atlaskit/section-message';
import { colors } from '@atlaskit/theme';
import { SpinnerMask } from '@atlassian/amkt-common';
import { TRUST_DATA_FORM_STATES } from '@atlassian/mpac-api-client';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { AppListing2LineSkeleton } from '@atlassian/mpac-primitives';
import { Certification, ExternalLink, useLocation } from '@atlassian/mpac-ui';
import { parse } from 'query-string';
import React from 'react';
import { appTrustDataAdapter } from '../AppTrustDataAdapter';
import { FeedbackCollectorWrapper } from '../CustomerComponents/FeedbackCollectorWrapper';
import { QuestionAnswerSection } from '../CustomerComponents/QuestionAnswerSection';
import { CustomerPrivacySecurityTabContent } from '../CustomerComponentsV2/CustomerPrivacySecurityTabContent';
import { useAppListingByIdForTrustTab, useAppTrustData } from '../hooks';
import { privacySecurityConfig } from '../privacySecurityConfig';
import { GetPrivacySecurityError } from '../utils/GetPrivacySecurityError';
import { getQnA } from '../utils/getQnA';
import { BannerTemplate, TabStyles } from './CustomerPrivacyAndSecurityTab.styles';
import LastUpdatedTimestamp from './LastUpdatedTimestamp';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _3 = "._otyru2gc{margin-bottom:var(--ds-space-100,8px)}";
const _2 = "._bfhk3739{background-color:#dfe1e6}";
const _ = "._4t3it94y{height:1px}";
const Separator = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_4t3it94y _bfhk3739 _otyru2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Separator.displayName = 'Separator';
}
export const CustomerPrivacyAndSecurityTabLoading = _ref2 => {
  let {
    enableAetherAppListingPageFlag
  } = _ref2;
  return enableAetherAppListingPageFlag ? /*#__PURE__*/_jsx(AppListing2LineSkeleton, {
    testId: "privacy-security-tab-skeleton"
  }) : /*#__PURE__*/_jsx(SpinnerMask, {
    active: true,
    testId: "trust-tab-spinner"
  });
};

// eslint-disable-next-line max-lines-per-function
export const CustomerPrivacyAndSecurityTab = _ref3 => {
  let {
    mpacBaseUrl,
    mpacCdnBaseUrl,
    appKey,
    appId,
    appName,
    feedbackCollectorApiKeys,
    feedbackGatewayBaseUrl,
    userId,
    supportEmailId
  } = _ref3;
  const {
    enableAetherAppListingPage
  } = useStatsig();
  const enableAetherAppListingPageFlag = enableAetherAppListingPage();
  const {
    search
  } = useLocation();
  const {
    showOnlyPublic
  } = parse(search || '');
  const {
    appTrustData,
    error: appTrustError,
    isPending: appTrustIsPending,
    reFetch: refetchTrustData
  } = useAppTrustData(mpacBaseUrl, appKey, TRUST_DATA_FORM_STATES.LIVE);
  const {
    data: appListingData,
    error: appListingError,
    loading: appListingIsPending
  } = useAppListingByIdForTrustTab({
    appId,
    mpacBaseUrl,
    mpacCdnBaseUrl,
    showOnlyPublic
  });
  const errorComponent = GetPrivacySecurityError(appListingError, appTrustError, undefined, refetchTrustData);
  if (errorComponent) return errorComponent;
  if (appTrustIsPending || appListingIsPending) {
    return /*#__PURE__*/_jsx(CustomerPrivacyAndSecurityTabLoading, {
      enableAetherAppListingPageFlag: enableAetherAppListingPageFlag
    });
  }
  const transformedAppTrustData = appTrustDataAdapter(appListingData, appTrustData);
  const bannerElement = /*#__PURE__*/_jsx(BannerTemplate, {
    children: /*#__PURE__*/_jsxs(SectionMessage, {
      appearance: "information",
      children: ["The information listed below is provided by the respective Marketplace Partner and pertains to the latest app version available on the Atlassian Marketplace. These policies and procedures are not controlled by Atlassian. The Marketplace Partner is solely responsible for the accuracy of the information provided.", ' ', /*#__PURE__*/_jsx(ExternalLink, {
        href: "https://developer.atlassian.com/platform/marketplace/security-privacy-tab/",
        children: "Learn how we collect the information"
      })]
    })
  });
  const {
    partner,
    cloudFortified,
    properties,
    security
  } = transformedAppTrustData;
  if (enableAetherAppListingPageFlag) {
    return /*#__PURE__*/_jsx(CustomerPrivacySecurityTabContent, {
      appName: appName,
      isEmptyState: !appTrustData,
      transformedAppTrustData: transformedAppTrustData,
      supportEmailId: supportEmailId,
      securityEmailId: security === null || security === void 0 ? void 0 : security.securityContact,
      partnerId: partner.id,
      mpacBaseUrl: mpacBaseUrl,
      feedbackGatewayBaseUrl: feedbackGatewayBaseUrl,
      feedbackCollectorApiKeys: feedbackCollectorApiKeys,
      userId: userId
    });
  }
  return /*#__PURE__*/_jsxs(TabStyles, {
    children: [!(transformedAppTrustData !== null && transformedAppTrustData !== void 0 && transformedAppTrustData.byAtlassian) && bannerElement, (properties === null || properties === void 0 ? void 0 : properties.updatedAt) && /*#__PURE__*/_jsx(LastUpdatedTimestamp, {
      timestamp: properties.updatedAt
    }), privacySecurityConfig.map(_ref4 => {
      let {
        heading,
        expandText,
        qna
      } = _ref4;
      return /*#__PURE__*/_jsx(QuestionAnswerSection, {
        questionAndAnswers: getQnA(qna, transformedAppTrustData),
        heading: heading,
        expandButton: {
          text: expandText,
          maxCount: 3
        }
      }, heading);
    }), (cloudFortified === null || cloudFortified === void 0 ? void 0 : cloudFortified.isStatusApproved) && partner.name && partner.url && /*#__PURE__*/_jsx(Certification, {
      appName: appName,
      partnerName: partner.name,
      partnerUrl: partner.url
    }), /*#__PURE__*/_jsx(Separator, {}), feedbackGatewayBaseUrl && feedbackCollectorApiKeys && /*#__PURE__*/_jsx(FeedbackCollectorWrapper, {
      feedbackGatewayBaseUrl: feedbackGatewayBaseUrl,
      feedbackCollectorApiKeys: feedbackCollectorApiKeys,
      userId: userId
    })]
  });
};
export default CustomerPrivacyAndSecurityTab;